import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitPlanModel } from '@apps-common/types/management/unit-plan'

export const MANAGEMENT_QUERY_KEY_SEARCH_UNIT_PLAN = (planId?: string) => ['getUnitPlan', planId].filter(Boolean)

export const getUnitPlan = async (planId: string): Promise<IUnitPlanModel> =>
  axios.get(`/management/unitplan/getunitplan?planId=${planId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitPlan

type Props = {
  config?: QueryConfig<QueryFnType>
  planId: string
}

export const useManagementGetUnitPlan = ({ config, planId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_SEARCH_UNIT_PLAN(planId),
    queryFn: () => getUnitPlan(planId)
  })
